import script from "./ChatDrawer.vue?vue&type=script&setup=true&lang=js"
export * from "./ChatDrawer.vue?vue&type=script&setup=true&lang=js"

import "./ChatDrawer.vue?vue&type=style&index=0&id=55649f6e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-55649f6e"]])

export default __exports__